import { ref, computed } from '@vue/composition-api';
import { iReview } from '@/entities/review/review.types';

const MAX_CHARS = 300;
export default function useReviewVariables(review: iReview) {
  const expandedText = ref(false);
  const showComment = ref(false);
  const comments = ref([]);
  const currentPage = ref(1);
  const allComments = ref([]);
  const maxPages = ref(1);

  const hasLongText = computed(() => review.text.length > MAX_CHARS);

  const processedText = computed(() => {
    if (!hasLongText.value || expandedText.value) {
      return review.text.trim();
    }

    return review.text
      .trim()
      .substring(0, 300)
      .concat('...');
  });

  return {
    expandedText,
    showComment,
    hasLongText,
    processedText,
    comments,
    currentPage,
    allComments,
    maxPages,
  };
}
